

























import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { updateAdmin, AdminCommonReq } from "@/api/admin";
import { ResCode, Admin } from "@/api/baseDefine";
import { getQiniuToken, QiniuTokenRes } from "../../api/admin";
@Component
export default class AdminUserInfo extends Vue {
  private admin: Admin = <Admin>{
    id: 0,
    language: ""
  };
  private languages: string[] = [];
  private qiniuData = {
    key: "", // 图片名字处理
    token: "", // 七牛云token
    domain: ""
  };
  private getAdminUserInfo() {
    this.admin.language = UserModule.language;
    this.admin.id = UserModule.id;
  }

  public async update() {
    const res = await updateAdmin(<AdminCommonReq>{ admin: this.admin });
    if (res && res.code === ResCode.SUCCESS) {
      this.$router.push('/dashboard')
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.updateUserInfoSuccess").toString(),
        type: "success"
      });
    }
  }

  private created() {
    this.getAdminUserInfo();
    this.languages = [
      this.$t("language.CN").toString(),
      this.$t("language.JAP").toString(),
      this.$t("language.English").toString()
    ];
  }
}
